/**
 * main.tsx - SSG-aware entry point.
 *
 * Uses `ViteReactSSG` factory tu vite-react-ssg de:
 *   - Build-time: prerender routes co `getStaticPaths` (blog 36 article)
 *     + cac route static (`/`, `/blog`, `/about`, ...). Output flat
 *     `dist/<route>/index.html`.
 *   - Runtime client: rehydrate vao `#root` voi same routes config,
 *     SPA navigation hoat dong nguyen ven cho auth/chat/dashboard
 *     (KHONG prerender vi cac route do co useAuth + client-only state).
 *
 * SSG dep: `vite-react-ssg` (0.9.x). Peer dep `react-helmet-async` cho
 * <Head> component. Vite plugin va router config doc tu `routes-config.tsx`.
 */

import { ViteReactSSG } from 'vite-react-ssg';
import { routes } from './routes-config';
import './styles/global.css';
import './styles/primitives.css';

export const createRoot = ViteReactSSG({
  routes,
  basename: import.meta.env.BASE_URL,
});
